import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
// import { siteDelete } from '../../../redux/api/siteAPI';
import { zoneDelete } from '../../../redux/api/zoneAPI';
import Input from '../../ui/input';
import Button from '../../ui/button';
import { useTranslation } from 'react-i18next';


const DeleteZoneModal = ({ isOpen, onClose, data }) => {
    const {t} = useTranslation('common');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [deleteMSG, setDeleteMSG] = useState("");
    const [MSGError, setMSGError] = useState("");

    const closeModal = (refresh = false) => {
        if (loading) return;
        onClose(refresh);
    };

    const handleChange = (e) => {
        e.preventDefault();
        setMSGError("");
        setError(null);
        setDeleteMSG(e.target.value);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const zonesToDelete = Array.isArray(data) ? data : [data.Zone_ID];

            if (!Array.isArray(data)) {
                const msg = `delete ${data.Zone_name}`.toLowerCase().replace(/\s/g, "");
                if (msg !== deleteMSG.toLowerCase().replace(/\s/g, "")) {
                    setMSGError("Confirmation message does not match.");
                    setLoading(false);
                    return;
                }
            }

            if (zonesToDelete.length === 0) {
                setLoading(false);
                closeModal();
                return;
            }

            const isBulkDelete = zonesToDelete.length > 1;

            const results = await Promise.all(
                zonesToDelete.map(id => zoneDelete(id, { skipSuccessToast: isBulkDelete }))
            );

            const errors = results
                .filter(result => result.error)
                .map(result => result.error);

            const successCount = zonesToDelete.length - errors.length;
            if (isBulkDelete && successCount > 0) {
                toast.success(`${successCount} zone(s) successfully deleted.`);
            }

            if (errors.length > 0) {
                setError(errors.join(', '));
                if (errors.length < zonesToDelete.length) {
                    onClose(true);
                }
            } else {
                closeModal(true);
            }
        } catch (err) {
            console.error("Error Deleting Zone(s):", err);
            setError("An unexpected error occurred.");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) {
        return null;
    }

    const isBulk = Array.isArray(data);
    const count = isBulk ? data.length : 1;
    const zoneName = !isBulk && data ? data.Zone_name : '';

    return (
        <div className="grid space-y-4 w-auto m-2 bg-white p-8 rounded-3xl shadow-lg">
            <p className="text-center text-xl text-[#4C4C66] font-bold">{t('delete_confirmation')}</p>
            <p className="text-center text-md text-[#4C4C66] font-normal">
                {isBulk
                    ? `Are you sure you want to delete ${count} zones?`
                    : `Type "delete ${zoneName}" to confirm.`
                }
            </p>
            {!isBulk && (
                <Input
                    data-testid="zone-delete-confirmation"
                    type="text"
                    placeholder={`delete ${zoneName}`}
                    value={deleteMSG}
                    onChange={handleChange}
                    className="w-full"
                />
            )}
            {MSGError && <p className="text-center text-red-500">{MSGError}</p>}
            {error && (
                <p className="text-center text-red-500 bg-red-100 p-2 rounded-md">{error}</p>
            )}
            <div className='flex justify-center pt-4 space-x-5'>
                <Button onClick={() => closeModal()} size="large" color="cancel" disabled={loading}>
                    {t('cancel')}
                </Button>
                <Button data-testid="zone-delete-submit" onClick={handleSubmit} type="submit" size="large" disabled={loading}>
                    {loading ? t('deleting') : t('delete')}
                </Button>
            </div>
        </div>
    );
};

export default DeleteZoneModal;
